// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__4BV0l","inner":"Footer_inner__WMqzc","nextIcon":"Footer_nextIcon__3FTL2","innerLeft":"Footer_innerLeft__3XcXa"};